/**
 * 单词熟悉度证据抽屉（旧 views/user/components/WordEvidenceDrawer.vue）：
 * 证据按发生时间倒序；分值与贡献来自同一服务端快照，合计直接显示该分值，不在浏览器重算或衰减
 */
import { Alert, Drawer, Empty, Spin } from 'antd'
import dayjs from 'dayjs'
import { getEventTypeConfig } from '@/config/eventTypes'
import { useWordEvidence } from './hooks'
import styles from './WordEvidenceDrawer.module.css'

interface WordEvidenceDrawerProps {
  userId: number
  lexemeId: number
  onClose: () => void
}

function errorText(error: any) {
  if (error?.response) return '获取单词证据失败：' + (error.response.data?.detail || error.message)
  return error?.message || '获取单词证据失败'
}

export function WordEvidenceDrawer({ userId, lexemeId, onClose }: Readonly<WordEvidenceDrawerProps>) {
  const { data: snapshot, isLoading, error } = useWordEvidence(userId, lexemeId)
  const evidence = [...(snapshot?.evidence ?? [])].sort(
    (a, b) => dayjs(b.occurred_at).valueOf() - dayjs(a.occurred_at).valueOf()
  )

  return (
    <Drawer
      open
      title={snapshot ? `${snapshot.word} · 熟悉度证据` : '熟悉度证据'}
      size="min(680px, 100vw)"
      onClose={onClose}
    >
      <Spin spinning={isLoading}>
        {error && <Alert type="error" title={errorText(error)} showIcon />}
        {!error && snapshot && (
          <div>
            <p className={styles.score}>熟悉度分值：{snapshot.score}</p>
            {evidence.length === 0 ? (
              <Empty description="暂无证据事件" />
            ) : (
              <ol className={styles.list}>
                {evidence.map((item) => (
                  <li key={item.evidence_id} className={styles.item} data-testid="evidence-item">
                    <strong>{getEventTypeConfig(item.event_type).label}</strong>
                    <p>来源文章：{item.source_episode_id}</p>
                    <p>发生时间：{dayjs(item.occurred_at).format('YYYY-MM-DD HH:mm:ss')}</p>
                    <p>当前贡献：{item.contribution}</p>
                  </li>
                ))}
              </ol>
            )}
            <p className={styles.score}>贡献合计：{snapshot.score}</p>
          </div>
        )}
      </Spin>
    </Drawer>
  )
}
